export const SEARCH_MIN_QUERY_LENGTH = 3;

export function isFullTextSearchQuery(trimmedQuery: string): boolean {
  return trimmedQuery.length >= SEARCH_MIN_QUERY_LENGTH;
}

export function filterChatsByTitle<Chat extends { title?: string | null }>(
  chats: Chat[],
  trimmedQuery: string
): Chat[] {
  const lowercaseQuery = trimmedQuery.toLowerCase();
  if (!lowercaseQuery) return chats;
  return chats.filter((chat) =>
    (chat.title || 'Untitled').toLowerCase().includes(lowercaseQuery)
  );
}

export function hasCurrentSearchResults(
  requestedQuery: string,
  storeQuery: string,
  isLoading: boolean
): boolean {
  return storeQuery.trim() === requestedQuery && !isLoading;
}
